import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { KeyRound } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';

export default function ForceChangePassword({ user, onDone, onLogout }) {
  const [form, setForm] = useState({ current: '', next: '', confirm: '' });
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (form.next !== form.confirm) return toast.error('New passwords do not match');
    if (form.next.length < 8) return toast.error('New password must be at least 8 characters');
    setSaving(true);
    try {
      await axios.post('/api/auth/change-password', { current_password: form.current, new_password: form.next });
      toast.success('Password updated');
      onDone();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Could not update password');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="min-h-screen bg-background grid-background flex items-center justify-center p-4">
      <Card className="w-full max-w-md glass-effect border-border/40" data-testid="force-change-password-card">
        <CardHeader>
          <CardTitle className="text-2xl flex items-center gap-2"><KeyRound className="w-5 h-5 text-primary" /> Set your password</CardTitle>
          <CardDescription>Hi {user.full_name}, please replace your temporary password before continuing.</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={submit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="cp-current">Temporary password</Label>
              <Input id="cp-current" type="password" value={form.current} onChange={set('current')} required data-testid="input-current-password" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="cp-new">New password</Label>
              <Input id="cp-new" type="password" value={form.next} onChange={set('next')} required data-testid="input-new-password" />
              <p className="text-xs text-muted-foreground">At least 8 characters.</p>
            </div>
            <div className="space-y-2">
              <Label htmlFor="cp-confirm">Confirm new password</Label>
              <Input id="cp-confirm" type="password" value={form.confirm} onChange={set('confirm')} required data-testid="input-confirm-password" />
            </div>
            <Button type="submit" className="w-full" disabled={saving} data-testid="btn-save-new-password">
              {saving ? 'Saving...' : 'Save and continue'}
            </Button>
            <button type="button" onClick={onLogout} className="w-full text-xs text-muted-foreground hover:underline" data-testid="btn-force-change-logout">Log out</button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
